import {ApiProtectedWS as http} from "../api/axios";
import {baseURL} from "../util/Constants";

class ReportsApiService {

    findReportToExport(startDate: string, endDate: string, currentDate:string, idUser: number, idProfile: number, idProject: number, idQuery:number) {
      console.log(startDate, endDate, currentDate, idProfile, idUser, idProject, idQuery);
      return http?.get(baseURL.readApi.reportsApi + "/findData?startDate="
          + startDate + "&endDate=" + endDate + "&currentDate=" + currentDate+"&idUser=" + idUser
          + "&idProfile=" + idProfile + "&idProject=" + idProject + "&idQuery="+idQuery);
  }
}

export default ReportsApiService;